import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { MenuService } from './side-menu.service';
import { SideNavComponent } from './side-nav/side-nav.component';

@Component({
  selector: 'app-side-menu',
  imports: [RouterModule, SideNavComponent],
  template: `
    <!-- DESKTOP MENU -->
    <div class="hidden md:fixed inset-y-0 z-40 md:flex lg:w-72 md:w-20 md:flex-col">
      <app-side-nav />
    </div>

    <!-- DEVICES MENU -->
    @if (menuService.menuOpen()) {
      <div @fadeInOut class="relative z-40 md:hidden" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-gray-900/80" aria-hidden="true"></div>

        <div class="fixed inset-0 flex">
          <div class="relative mr-16 flex w-full max-w-xs flex-1">
            <div class="absolute top-0 left-full flex w-16 justify-center pt-5">
              <button type="button" class="-m-2.5 p-2.5 cursor-pointer" (click)="menuService.toggleMenu()">
                <span class="sr-only">Close sidebar</span>
                <svg class="size-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <app-side-nav />
          </div>
        </div>
      </div>
    } @else {

    }
  `,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0, transform: 'translateY(0)' }), animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))]),
      transition(':leave', [animate('100ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class SideMenuComponent {
  menuService = inject(MenuService);
}
